import { collection, getDocs, doc, setDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { calculateLaborCost } from "./calculateLaborCost";

export const recalculateJobLabor = async (jobId) => {
  if (!jobId) return;

  console.log("Recalculating labor for job:", jobId);

  // 1️⃣ Load all time logs
  const logsSnap = await getDocs(collection(db, "time_logs"));

  const jobLogs = logsSnap.docs
    .map(d => d.data())
    .filter(log => String(log.jobId) === String(jobId));

  if (jobLogs.length === 0) {
    console.warn("No time logs found for job", jobId);
    return;
  }

  // 2️⃣ Load users (NOT staff)
  const usersSnap = await getDocs(collection(db, "users"));
  const usersMap = {};
  usersSnap.forEach(doc => {
    usersMap[doc.id] = doc.data();
  });

  let totalLabor = 0;

  // 3️⃣ Calculate labor
  jobLogs.forEach(log => {
    const user = usersMap[log.userId];
    if (!user) return;

    // ⏱️ Calculate hours safely
    let hours = 0;

    if (log.duration) {
      hours = Number(log.duration);
    } else if (log.clockIn && log.clockOut) {
      const start = log.clockIn.toDate?.() || new Date(log.clockIn);
      const end = log.clockOut.toDate?.() || new Date(log.clockOut);
      hours = (end - start) / (1000 * 60 * 60);
    }

    if (hours <= 0) return;

    const cost = calculateLaborCost({
      hours,
      hourlyRate: Number(user.hourlyRate || 0),
      payType: user.payType || "hourly",
      commissionRate: Number(user.commissionRate || 0),
      jobRevenue: 0,
    });

    totalLabor += cost;
  });

  // 4️⃣ Write to Firestore
  await setDoc(
    doc(db, "job_costs", String(jobId)),
    {
      jobId: String(jobId),
      labor: Number(totalLabor.toFixed(2)),
      updatedAt: new Date(),
    },
    { merge: true }
  );

  console.log("Labor updated:", totalLabor);
};
